/**
 * Table State Components
 *
 * Empty state and loading skeleton components.
 */
type EmptyStateProps = { colSpan: number };

export const EmptyState = ({ colSpan }: EmptyStateProps) => (
  <tr>
    <td colSpan={colSpan} className="px-6 py-8 text-center text-gray-500">
      Aucune colonne sélectionnée
    </td>
  </tr>
);

type LoadingSkeletonProps = {
  colSpan: number
  rowCount: number
};

export const LoadingSkeleton = ({ colSpan, rowCount }: LoadingSkeletonProps) => (
  <>
    {Array.from({ length: rowCount }).map((_, rowIndex) => (
      <tr key={rowIndex} className="animate-pulse">
        <td colSpan={colSpan} className="px-6 py-4">
          <div className="h-4 bg-gray-300 rounded w-full" />
        </td>
      </tr>
    ))}
  </>
);
